import { isDefined } from "@clipboard-health/util-ts";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

import { type WorkerRequirement } from "../api/types";

// A filter function to exclude documents based on the DOCUMENT_EXCLUSION_LIST feature flag.
// Currently used to filter out some child-care documents from showing on the mandatory, workplace-
// specific, and sign-up document pages
export function useDocumentExclusionFilter<T = WorkerRequirement>(
  getRequirementId?: (document: T) => string
) {
  const exclusionList = useCbhFlag(CbhFeatureFlag.DOCUMENT_EXCLUSION_LIST, {
    defaultValue: { ids: [] }, // Explicit fallback to avoid Zod validation issues
  });

  return (documents: T[]): T[] => {
    const exclusionIds = exclusionList?.ids;
    if (!isDefined(exclusionIds)) {
      return documents;
    }

    const exclusionIdsSet = new Set(exclusionIds);

    return documents.filter((document) => {
      // Use provided getter function or default to WorkerRequirement.requirementId
      const requirementId = getRequirementId
        ? getRequirementId(document)
        : (document as unknown as WorkerRequirement).requirementId;

      return !exclusionIdsSet.has(requirementId);
    });
  };
}
